export class WtpRentalPropertyRequestData {
    constructor(propertyId: number, propertyType: number, isStringValue: boolean) {
        this.propertyId = propertyId;
        this.propertyType = propertyType;
        this.isStringValue = isStringValue;
    }

    propertyId: number;
    propertyType: number;
    propertyNumericValue: number;
    propertyTextValue: string;
    isStringValue: boolean;
}